<script setup lang="ts">
const props = defineProps<{
  href?: string
  arrowLeft?: boolean
  target?: string
}>()
</script>

<template>
  <NuxtLink
    :to="props?.href"
    :target="props?.target"
    class="px-2.5 py-7.5 flex flex-row gap-10 xl:gap-20 items-center justify-between border-b border-Tertiary w-fit group"
  >
    <i
      v-if="props.arrowLeft"
      class="pi pi-arrow-left text-2xl! text-Tekst group-hover:text-Secondary transition-all duration-300"
    />
    <span class="text-Menu text-Tekst group-hover:text-Secondary transition-all duration-300">
      <slot />
    </span>
    <i
      v-if="!props.arrowLeft"
      class="pi pi-arrow-right text-2xl! text-Tekst group-hover:text-Secondary transition-all duration-300"
    />
  </NuxtLink>
</template>
